"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlotAssistantDayBoundaryResponseSchema = exports.slotAssistantDayBoundarySchema = exports.getSlotAssistantDayBoundaryQuerySchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
/**
 * Query payload for the slot assistant day-boundary endpoint: the slot's
 * half-day. The extension is a pure function of the period — a `morning` slot
 * opens the day, an `afternoon` slot closes it, `allday` does both — so the
 * server needs nothing else.
 */
exports.getSlotAssistantDayBoundaryQuerySchema = zod_1.z.object({
    periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
});
/**
 * Whether the slot opens and/or closes its office-day, i.e. whether its
 * effective assistant window is widened to the day's opening start / closing
 * end. Lets the client clip displayed assistant periods to the same window the
 * billing math uses.
 */
exports.slotAssistantDayBoundarySchema = zod_1.z.object({
    extendsToDayStart: zod_1.z.boolean(),
    extendsToDayEnd: zod_1.z.boolean(),
});
exports.getSlotAssistantDayBoundaryResponseSchema = zod_1.z.object({
    data: exports.slotAssistantDayBoundarySchema,
});
